// В.2.g: Военный учёный Бьорк (liv_voennyy_uchenyy_bork, Герой Лив Лайф, 2/1/12).
// Триггер: «[Когда союзный персонаж лечится]: наносит 1 урон случайному
//           врагу».
//
// Регистрируется как side-aware observer на событие healed: срабатывает,
// когда healEvent.target.ownerId === Бьорка.ownerId (т.е. лечится свой юнит
// или сам Бьорк). actualAmount > 0 уже гарантирован healUnit'ом (событие
// эмитится только при реальном хиле).
//
// Эффект: 1 урон случайному вражескому персонажу через applyDamage.
// Кандидаты:
//   - Все живые вражеские юниты.
//   - Вражеский Герой только если у врага НЕТ живых юнитов (Авангард снят).
// Если кандидатов нет — пропуск.
//
// Молчание Бьорка блокирует триггер (это уже в каркасе observer'ов).

import { registerOnAllyHealedObserver } from './heal.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { applyDamage } from '../../combat.js';
import { onUnitDamaged, onHeroDamaged } from '../deus/index.js';
import { dispatchUnitDied } from '../deus/hooks.js';

export const HERO_ID = 'liv_voennyy_uchenyy_bork';
const LABEL = 'Бьорк';
const DAMAGE = 1;

registerImplementedAbility(HERO_ID, 'trigger');

registerOnAllyHealedObserver(HERO_ID, (state, bork, healEvent) => {
  if (!healEvent || (healEvent.amount ?? 0) <= 0) return;
  // В.2.h-rebalance: маркер fromBorkActive больше не нужен — старая активка
  // удалена. Новая активка (overflow-хил всем своим) намеренно стреляет
  // триггером на каждом успешном хиле; цикла нет (applyDamage не зовёт healUnit).
  const ownerIdx = bork.ownerId;
  if (ownerIdx == null) return;
  const enemy = state.players[1 - ownerIdx];
  if (!enemy) return;
  const enemyUnits = enemy.unitsOnField().filter(u => u.isAlive());
  let target;
  if (enemyUnits.length > 0) {
    target = enemyUnits[state.rng.int(enemyUnits.length)];
  } else if (enemy.hero?.hp > 0) {
    target = enemy.hero;
  } else {
    return; // Герой мёртв и юнитов нет.
  }
  const isHero = target.type === 'hero';
  const before = { hp: target.current?.hp ?? target.hp, armor: target.current?.armor ?? target.armor };
  const r = applyDamage(target, DAMAGE, { state, source: bork });
  const taken = (r.armorAbsorbed || 0) + (r.hpLost || 0);
  state.log?.add(
    `🩸 ${LABEL} [${state.players[ownerIdx]?.name}]: триггер хила ${healEvent.target?.name_ru || '?'} → ` +
    `${DAMAGE} урон ${target.name_ru || target.id} ` +
    `(HP ${before.hp}→${target.hp}, броня ${before.armor}→${target.armor})`
  );
  if (isHero) {
    if (taken > 0) onHeroDamaged(state, 1 - ownerIdx, taken);
  } else {
    if (taken > 0) onUnitDamaged(state, { ownerIdx: 1 - ownerIdx, card: target, dmg: taken });
    if (target.hp <= 0) {
      enemy.removeFromField(target);
      state.log?.add(`✗ ${target.name_ru} [${enemy.name}] погибает (от ${LABEL})`);
      dispatchUnitDied(state, {
        ownerIdx: 1 - ownerIdx, card: target,
        killer: bork, killerIdx: ownerIdx, killerWasCounter: false
      });
    }
  }
});
